$ ->
  if $('#snackbar_component').length > 0
    elm = require('../../../../elm/elm.js')
    app = elm.SnackbarMain.embed($('#snackbar_component').get()[0])
    $('#snackbar_component').data(
      'snackbar',
      (msg)->
        app.ports.snackbar.send(msg)
    )

module.exports = (msg)->
  if $('#snackbar_component').length > 0 && $('#snackbar_component').data('snackbar')?
    $('#snackbar_component').data('snackbar')(msg)
